import React from 'react';
import { MODAL_STYLES } from '../../constants/styles';
import ProteinSubstitutionSection from '../Substitution/ProteinSubstitutionSection';
import VeggieSubstitutionSection from '../Substitution/VeggieSubstitutionSection';
import StarchSubstitutionSection from '../Substitution/StarchSubstitutionSection';
import SauceSubstitutionSection from '../Substitution/SauceSubstitutionSection';
import GarnishSubstitutionSection from '../Substitution/GarnishSubstitutionSection';

const MealModal = ({
    meal,
    onClose,
    modalRef,
    saving,
    onProteinSubstitution,
    onVeggieSubstitution,
    onSauceSubstitution,
    onStarchSubstitution,
    onToggleGarnish,
    isLocked,
    showAddedBanner = false,
    billingChanges,
    deliveryDates,
    selectedDeliveryDate
}) => {
    return (
        <div
            className="meal-modal-container"
            style={MODAL_STYLES.overlay}
            onClick={onClose}
        >
            <div
                ref={modalRef}
                className='meal-modal'
                style={MODAL_STYLES.content}
                onClick={(e) => e.stopPropagation()}
            >

                <button
                    onClick={onClose}
                    style={MODAL_STYLES.closeButton}
                >
                    ×
                </button>

                <div style={{ padding: '20px' }}>
                    {/* Added Banner */}

                    {showAddedBanner && meal.originalIngredients.filter(ingredient => !meal.finalIngredients.some(finalIngredient => finalIngredient.id === ingredient.id)).length > 0 && (
                        <div style={{
                            backgroundColor: '#d4edda',
                            border: '1px solid #c3e6cb',
                            borderRadius: '18px',
                            padding: '6px 5px',
                            fontSize: '16px',
                            color: '#155724',
                            fontWeight: '500',
                            textAlign: 'center',
                            marginBottom: '10px',
                            width: '88%',
                            margin: '0 auto 10px auto'
                        }}>
                            Following ingredients are removed per your allergies notes:<br />
                            {meal.originalIngredients.filter(ingredient => !meal.finalIngredients.some(finalIngredient => finalIngredient.id === ingredient.id)).map(ingredient => ingredient.name.trim()).join(', ')}
                        </div>
                    )}
                    <div
                        className="meal-modal-content"
                        style={{
                            display: 'flex',
                            gap: '20px',

                            alignItems: 'flex-start'
                        }}>
                        {/* Image section */}
                        <div
                            className="meal-modal-image"
                            style={{
                                flex: '0 0 300px',
                                minHeight: '200px'
                            }}>
                            {meal.imageUrl && (
                                <img
                                    src={meal.imageUrl}
                                    alt={meal.itemName}
                                    style={{
                                        width: '100%',
                                        height: '200px',
                                        objectFit: 'cover',
                                        borderRadius: '8px'
                                    }}
                                />
                            )}
                        </div>

                        {/* Details section */}
                        <div
                            className="meal-modal-details"
                            style={{
                                flex: '1',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '15px'
                            }}>
                            {/* Title */}
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start'
                            }}>
                                <div>
                                    <h4 style={{ margin: '0 0 5px 0', color: '#333' }}>
                                        {meal.itemName}
                                        {meal.itemName.length > 30 && (
                                            <div />
                                        )}
                                        {meal.quantity === 0 && (
                                            <>
                                                <span style={{
                                                    width: 'fit-content',
                                                    margin: '0 8px 8px 0',
                                                    fontSize: '12px',
                                                    backgroundColor: '#e3f2fd',
                                                    color: '#1976d2',
                                                    padding: '2px 6px',
                                                    borderRadius: '3px'
                                                }}>
                                                    Available to Add
                                                </span>
                                            </>
                                        )}
                                    </h4>
                                    {meal.quantity === 0 && (
                                        <div style={{
                                            backgroundColor: '#e3f2fd',
                                            border: '1px solid #bbdefb',
                                            borderRadius: '6px',
                                            padding: '12px',
                                            fontSize: '14px',
                                            color: '#1565c0'
                                        }}>
                                            <strong>Available Dish:</strong> This dish is available for this week but not currently in your meal plan. Click "Add" to add it to your orders!
                                        </div>
                                    )}
                                    {(meal.meal === 'Add On' || meal.meal === 'Snack' || meal.meal === 'Breakfast') && meal.price > 0 && <label style={{
                                        display: 'block',
                                        margin: '8px 0 0 0',
                                        fontSize: '14px',
                                        fontWeight: 'bold',
                                        color: '#555'
                                    }}>
                                        Price: ${meal.price}
                                    </label>
                                    }



                                </div>
                            </div>
                            {/* Show substitution options for ordered dishes only */}
                            {meal.quantity > 0 && (

                                <>
                                    {meal.proteinOptions.length > 0 && (
                                        <ProteinSubstitutionSection
                                            order={meal}
                                            orderIndex={meal.actualIndex}
                                            onProteinSubstitution={onProteinSubstitution}
                                            isLocked={isLocked}
                                            saving={saving}
                                            billingChanges={billingChanges}
                                            deliveryDates={deliveryDates}
                                            selectedDeliveryDate={selectedDeliveryDate}
                                        />)}

                                    {meal.veggieOptions.length > 0 && (
                                        <VeggieSubstitutionSection
                                            order={meal}
                                            orderIndex={meal.actualIndex}
                                            onVeggieSubstitution={onVeggieSubstitution}
                                            isLocked={isLocked}
                                            saving={saving}
                                        />
                                    )}
                                    {meal.starchOptions.length > 0 && (
                                        <>
                                            <StarchSubstitutionSection
                                                order={meal}
                                                orderIndex={meal.actualIndex}
                                                onStarchSubstitution={onStarchSubstitution}
                                                isLocked={isLocked}
                                                saving={saving}
                                            />
                                        </>
                                    )}
                                    {meal.sauceOptions.length > 0 && (
                                        <SauceSubstitutionSection
                                            order={meal}
                                            orderIndex={meal.actualIndex}
                                            onSauceSubstitution={onSauceSubstitution}
                                            isLocked={isLocked}
                                            saving={saving}
                                        />
                                    )}
                                    {meal.garnishOptions.length > 0 && (
                                        <GarnishSubstitutionSection
                                            order={meal}
                                            orderIndex={meal.actualIndex}
                                            onToggleGarnish={onToggleGarnish}
                                            isLocked={isLocked}
                                            saving={saving}
                                        />
                                    )}


                                    {/* Ingredients section for snacks */}
                                    {/* {meal.meal === 'Snack' && (meal.originalIngredients && meal.originalIngredients.length === 1) && (
                                        <div>
                                            <label style={{
                                                display: 'block',
                                                marginBottom: '8px',
                                                fontSize: '14px',
                                                fontWeight: 'bold',
                                                color: '#555'
                                            }}>
                                                All Ingredients:
                                            </label>
                                            <div
                                                className="ingredient-buttons"
                                                style={{
                                                    display: 'flex',
                                                    flexWrap: 'wrap',
                                                    gap: '8px'
                                                }}>
                                                {meal.originalIngredients.map((ingredient, ingredientIndex) => {
                                                    const isActive = meal.finalIngredients.includes(ingredient.id);
                                                    return (
                                                        <button
                                                            key={ingredientIndex}
                                                            className="ingredient-button"
                                                            onClick={() => onToggleIngredient(meal.actualIndex, ingredient.name, isActive)}
                                                            disabled={saving}
                                                            style={getIngredientButtonStyle(isActive, saving)}
                                                            title={isActive ? `Remove ${ingredient.name}` : `Add ${ingredient.name}`}
                                                        >
                                                            <span style={{
                                                                marginRight: '4px',
                                                                fontSize: '12px'
                                                            }}>
                                                                {isActive ? '✓' : '+'}
                                                            </span>
                                                            {ingredient.name}
                                                        </button>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    )} */}
                                </>
                            )}

                            {/* Show ingredients preview for available dishes */}
                            {meal.quantity === 0 && (
                                <div>
                                    <label style={{
                                        display: 'block',
                                        marginBottom: '8px',
                                        fontSize: '14px',
                                        fontWeight: 'bold',
                                        color: '#555'
                                    }}>
                                        What's included:
                                    </label>
                                    <div style={{
                                        fontSize: '14px',
                                        color: '#666',
                                        lineHeight: '1.6'
                                    }}>
                                        {(() => {
                                            const categories = [
                                                { label: 'Protein', options: meal.proteinOptions, showSubs: true },
                                                { label: 'Starch', options: meal.starchOptions, showSubs: true },
                                                { label: 'Vegetables', options: meal.veggieOptions, showSubs: false },
                                                { label: 'Sauce', options: meal.sauceOptions, showSubs: true },
                                                { label: 'Garnish', options: meal.garnishOptions, showSubs: false },
                                            ];
                                            const originalIds = new Set((meal.originalIngredients || []).map(i => i.id));
                                            const lines = categories
                                                .map(({ label, options, showSubs }) => {
                                                    if (!options || !Array.isArray(options)) return null;
                                                    const display = options.filter(o => originalIds.has(o.id));
                                                    if (display.length === 0) return null;
                                                    const stripSF = (s) => (s || '').replace(/^SF /, '');
                                                    const namesList = display.map(o => {
                                                        const cleanSubs = (o.subIngredientNames || []).map(stripSF);
                                                        const subs = showSubs && cleanSubs.length > 0
                                                            ? ` (${cleanSubs.join(', ')})`
                                                            : '';
                                                        return { name: stripSF(o.name?.trim()), subs, rawSubs: cleanSubs };
                                                    });
                                                    return { label, namesList };
                                                })
                                                .filter(Boolean);

                                            if (lines.length === 0) {
                                                return meal.originalIngredients?.length > 0
                                                    ? meal.originalIngredients.map(i => i.name.trim()).join(', ')
                                                    : 'Original Ingredients Not Listed';
                                            }

                                            const singleCategory = lines.length === 1;
                                            if (singleCategory) {
                                                return lines[0].namesList.map((item, i) => {
                                                    const nameL = item.name?.toLowerCase() || '';
                                                    const titleL = meal.itemName?.toLowerCase() || '';
                                                    const sameName = nameL === titleL || titleL.includes(nameL) || nameL.includes(titleL);
                                                    const subsText = item.subs || (item.rawSubs.length > 0 ? ` (${item.rawSubs.join(', ')})` : '');
                                                    if (sameName && !subsText) {
                                                        return null;
                                                    }
                                                    return <div key={i}><span style={{ fontWeight: '600' }}>{item.name}</span>{subsText}</div>;
                                                });
                                            }
                                            return lines.map((line, i) => (
                                                <div key={i}>
                                                    <span style={{ fontWeight: '600' }}>{line.label}:</span> {line.namesList.map(item => item.name + item.subs).join(', ')}
                                                </div>
                                            ));
                                        })()}
                                    </div>

                                </div>
                            )}
                        </div>
                    </div>
                </div>

            </div>
        </div >
    );
};

export default MealModal;